import { getScreenSize, variables } from "./components/variables";
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


(function($) {


    // Get all event widgets with swiper added
    const $eventsSwiper = $('.eventsWidget--swiper');
    if ( $eventsSwiper.length ) {
        $eventsSwiper.each(function(){

            // Get all data attributes for swiper parameters
            let args = {
                slidesPerView: $(this).data('swiper-slides'),
                spaceBetween: $(this).data('swiper-gap'),
                slidesOffsetAfter: $(this).data('swiper-offset-after'),
                speed: 800,
                autoplay: {
                    delay: 5000
                }
            };



            // Initialize Swiper
            const swiper = new Swiper($(this)[0], args);

        });
    }


})( jQuery );